export var FILTER_HEAD = "Filters";
export var FILTER_SUBHEAD = "Select category filters to enhance your search results.";
export var SELECT_ALL = "Select all";
export var CLEAR_FILTERS = "Clear filters";
export var CANCEL = "Cancel";
export var APPLY = "Apply filters";